<template>
  <b-form-group
    label="Başlık"
    :label-for="'title_' + keyNumber"
  >
    <validation-provider
      #default="{ errors }"
      name="Başlık"
      rules="required"
    >
      <b-form-input
        :id="'title_' + keyNumber"
        :key="keyNumber"
        v-model="dataList[keyNumber].title"
        placeholder="Başlık"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'TitleText',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  props: {
    keyNumber: {
      type: Number,
      required: true,
    },
  },
  computed: {
    dataList() {
      return this.$store.getters['productMaterials/dataList']
    },
  },
}
</script>
